// @flow
import JQueryView from '../../common/JQueryView';
import { validateEmail } from '../validators';

export default class ConfirmationFormView extends JQueryView {
  constructor() {
    super('#form-confirmation');
    this.render();
  }

  render() {
    this.$el.validate();
    validateEmail();
  }
}
